import React from "react";

export default function TermsConditions() {
  return (
    <div className="policyPage">
      <div className="policyPage__text">
        <h2>Terms & Conditions</h2>
        <p>
          X-Cloud Solutions may collect personal information when USER register
          for an account, place an order or provide information through other
          means, We may use information for marketing purpose and provide USER
          better user experience.
        </p>
        <p>
          X-Cloud Solutions may use cookies and other IT technologies to improve
          the quality of service and enhance USER online experience
        </p>
        <p>
          X-Cloud Solutions record USER information when USER visit our Web
          Sites including but not limited to IP address, browser type, date,
          time and language
        </p>
        <p>
          Payment process is entirely handled by re-known payment merchants and
          we do not store any financial information (such as credit card etc)
        </p>
        <p>
          X-Cloud Solutions will not sell , share or provide USER personal or
          corporate information to third party
        </p>
        <p>
          X-Cloud Solutions agrees to offer full refund on remaining prepaid
          positive balances upon request for all payments made within 60 days
        </p>
        <p>
          X-Cloud Solutions do not offer refund for monthly subscriptions ,
          support services , one time / setup fee and others
        </p>
      </div>
      <div className="policyPage__image">
        <img src="/images/termsImage.png" alt="" />
      </div>
    </div>
  );
}
